import { render, staticRenderFns } from "./ModalPreviewEmailWeekly.vue?vue&type=template&id=3c060879&scoped=true&"
import script from "./ModalPreviewEmailWeekly.vue?vue&type=script&lang=js&"
export * from "./ModalPreviewEmailWeekly.vue?vue&type=script&lang=js&"
import style0 from "./ModalPreviewEmailWeekly.vue?vue&type=style&index=0&id=3c060879&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c060879",
  null
  
)

export default component.exports